<div class="control-card-content">

    <div *ngIf="userCanExecutionEdit" class="buttons-container">

        <ng-container id="addAutomation">
            <a (click)="addAutomation()" class="button">
                <ng-container i18n="@@automation_add_automation">Aggiungi automazione
                </ng-container> <span>
                    <fa-icon icon="clock"></fa-icon>
                </span>
            </a>
        </ng-container>
    </div>

    <div class="table-filter-automations">
        <p i18n="@@automations_filter">Filtra: </p>
        <input id="filter-input" (keyup)="onKey($event)" />
    </div>


    <table mat-table matSort #automationsTable class="simple-table">

        <ng-container matColumnDef="serial">
            <th mat-header-cell mat-sort-header *matHeaderCellDef i18n="@@automations_serial" style="width: 10%;">
                Seriale
            </th>
            <td mat-cell *matCellDef="let element"> {{ element.serial }} </td>
        </ng-container>

        <ng-container matColumnDef="deviceReference">
            <th mat-header-cell mat-sort-header *matHeaderCellDef i18n="@@automations_reference" style="width: 11%;">
                Riferimento
            </th>
            <td mat-cell *matCellDef="let element"> {{ element.deviceReference }} </td>
        </ng-container>

        <ng-container matColumnDef="name">
            <th mat-header-cell mat-sort-header *matHeaderCellDef i18n="@@automations_description" style="width: 20%;">
                Descrizione
            </th>
            <td mat-cell *matCellDef="let element"> {{ element.name }} </td>
        </ng-container>

        <ng-container matColumnDef="startDateFriendly">
            <th mat-header-cell mat-sort-header *matHeaderCellDef i18n="@@automations_from_date" style="width: 14%;">
                Data inizio
            </th>
            <td mat-cell *matCellDef="let element"> {{ element.startDateFriendly }} </td>
        </ng-container>

        <ng-container matColumnDef="expirationDateFriendly">
            <th mat-header-cell mat-sort-header *matHeaderCellDef i18n="@@automations_to_date" style="width: 14%;">Data
                fine
            </th>
            <td mat-cell *matCellDef="let element"> {{ element.expirationDateFriendly }} </td>
        </ng-container>



        <ng-container matColumnDef="daysAllowed">
            <th mat-header-cell *matHeaderCellDef i18n="@@periodic_executions_days_allowed"
                style="width: 13%;">Giorni settimanali
            </th>
            <td mat-cell *matCellDef="let element"> {{ element.daysAllowed }} </td>
        </ng-container>

        <ng-container matColumnDef="hoursAllowed">
            <th mat-header-cell *matHeaderCellDef i18n="@@periodic_executions_hours_allowed"
                style="width: 13%;">Fasce orarie
            </th>
            <td mat-cell *matCellDef="let element"> {{ element.hoursAllowed }} </td>
        </ng-container>

        <!-- 
    <ng-container matColumnDef="result">
      <th mat-header-cell mat-sort-header *matHeaderCellDef i18n="@@automations_result" style="width: 15%;">Stato
      </th>
      <td mat-cell *matCellDef="let element"> {{ element.result }} </td>
    </ng-container> -->

        <ng-container matColumnDef="deleteAutomation">
            <th mat-header-cell *matHeaderCellDef> </th>
            <td mat-cell *matCellDef="let element">
                <fa-icon *ngIf="userCanExecutionEdit" icon="trash" class="float-right padding-5 icon-clickable"
                    (click)="deleteAutomation(element)">
                </fa-icon>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumnsAutomations"></tr>

        <tr mat-row *matRowDef="let row; columns: displayedColumnsAutomations;"></tr>

    </table>

</div>
<app-loading-screen #automationsloader [loading]="false"></app-loading-screen>